const getters = {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    companyInfo: state => state.user.companyInfo,
    
  }
  export default getters
  